import React, { useState } from "react";
import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink
} from "reactstrap";
import classnames from "classnames";
import css from "./Settings.module.css";
import "./Settings.css";
import Rotation from "./settings/Rotation";
import Size from "./settings/Size";
import Theme from "./settings/Theme";
import Table from "./settings/Table";
import Addons from "./settings/Addons";
import Ring from "./settings/Ring";
import { useStore } from "store";
import { useTranslation } from "react-i18next";
import { FiCheckCircle } from "react-icons/fi";
import useImagePreloader from "hooks/useImagePreloader";

function Settings({ data }) {
	useImagePreloader(data)
	const { i18n } = useTranslation()
	const t = useStore(state => state.translations)
	const [activeTab, setActiveTab] = useState("1");
	const rotation = useStore(state => state.rotation)
	const size = useStore(state => state.size)
	const theme = useStore(state => state.theme)
	const table = useStore(state => state.table)
	const ring = useStore(state => state.ring)
	const control = useStore(state => state.control)

	const themes = Object.keys(data.themes).length > 0 && Object.entries(data.themes).filter(([_, t]) =>  t.size === size).sort((a, b) => b[1].price - a[1].price)
	const tables = Object.keys(data.tables).length > 0 && Object.entries(data.tables).filter(([_, t]) =>  t.size === size).sort((a, b) => b[1].price - a[1].price)
	const rings = Object.keys(data.rings).length > 0 && Object.entries(data.rings).filter(([_, t]) =>  t.size === size).sort((a, b) => b[1].price - a[1].price)

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};
	return (
		<div className={classnames("mt-0 mb-5", css.settingsWrapper)}>
			<Nav className={css.nav} tabs >
				<img src={process.env.PUBLIC_URL + "/img/dots.png"} className={css.dots} alt ="Dots" />
				<NavItem  className={css.navItem}>
					<NavLink
						className={classnames({ active: activeTab === "1" }, css.navLink, { finished: !!size })}
						onClick={() => {
							toggle("1");
						}}
					>
						{size && (<><FiCheckCircle /><br /></>)}
						{t.navigation.size[i18n.language]}
					</NavLink>
				</NavItem>
				{size === "size_180cm_x_55cm" && (
					<NavItem className={css.navItem}>
						<NavLink
							className={classnames({ active: activeTab === "2" }, css.navLink, { finished: !!rotation })}
							onClick={() => {
								toggle("2");
							}}
						>
							{rotation && (<><FiCheckCircle /><br /></>)}
							{t.navigation.rotation[i18n.language]}
						</NavLink>
					</NavItem>
				)}
				<NavItem className={css.navItem}>
					<NavLink
						className={classnames({ active: activeTab === "3" }, css.navLink, { finished: !!theme })}
						onClick={() => {
							toggle("3");
						}}
					>
						{theme && (<><FiCheckCircle /><br /></>)}
						{t.navigation.theme[i18n.language]}
					</NavLink>
				</NavItem>
				<NavItem className={css.navItem}>
					<NavLink
						className={classnames({ active: activeTab === "4" }, css.navLink, { finished: !!table })}
						onClick={() => {
							toggle("4");
						}}
					>
						{table && (<><FiCheckCircle /><br /></>)}
						{t.navigation.table[i18n.language]}
					</NavLink>
				</NavItem>
				{rotation !== "pole" && (
					<NavItem className={css.navItem}>
						<NavLink
							className={classnames({ active: activeTab === "5" }, css.navLink, { finished: !!ring })}
							onClick={() => {
								toggle("5");
							}}
						>
							{ring && (<><FiCheckCircle /><br /></>)}
							{t.navigation.ring[i18n.language]}
						</NavLink>
					</NavItem>
				)}
				<NavItem className={css.navItem}>
					<NavLink
						className={classnames({ active: activeTab === "6" }, css.navLink, { finished: !!control })}
						onClick={() => {
							toggle("6");
						}}
					>
						{control && (<><FiCheckCircle /><br /></>)}
						{t.navigation.addons[i18n.language]}
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={activeTab} className={css.tabContent}>
				<TabPane tabId="1" className={css.tabPane}>
					<Size data={data.sizes} />
				</TabPane>
				{size === "size_180cm_x_55cm" && (
				<TabPane tabId="2">
					<Rotation data={data.rotations} />
				</TabPane>
				)}
				<TabPane tabId="3">
					<Theme data={themes} />
				</TabPane>
				<TabPane tabId="4">
					<Table data={tables} />
				</TabPane>
				{rotation !== "pole" && (
					<TabPane tabId="5">
						<Ring data={rings} />
					</TabPane>
				)}
				<TabPane tabId="6">
					<Addons data={data.addons} />
				</TabPane>
			</TabContent>
		</div>
	);
}

export default Settings;
